import React from "react";
import { useHistory, useParams } from "react-router-dom";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";

import { useState } from "react";
import { CaretDown, PencilSimple, XCircle } from "phosphor-react";
import RequiredLabel from "../../CustomCommons/RequiredLabel";
import PhoneInput from "react-phone-input-2";
import "./../invoice.css";

import Select from "react-select";

import { handleInputs } from "../../../utils/HandleInputs";
import { showToast } from "../../../utils/ToastHelper";
import axios from "axios";
import ImageZoom from "../../Const/ImageZoom";
import { BASE_URL } from "../../Const/Url";
import { useEffect } from "react";
import * as path from "../../Routes/RoutePaths";
import CreatableSelect from "react-select/creatable";
import swal from "sweetalert";

import PreviewEdit from "./../PreviewEdit";
import { useRef } from "react";

import { useReactToPrint } from "react-to-print";
import Loader from "../../CustomCommons/Loader";
import { Controller, useForm } from "react-hook-form";
import CreateWithPathaoWeb from "../Pathao/CreateWithPathaoWeb";
import divisions from "../../../assets/json/bd_divisions.json";
import DoIcon from "../../CustomCommons/DoIcon";
const EditWebInvoiceUpdated = () => {
  const [customCharge, setCustomCharge] = useState(80);
  const [customPrice, setCustomPrice] = useState(0);
  const [OnlogoutHide, setOnlogoutHide] = useState(0);
  const { id } = useParams();
  const [sInvoice, setSInvoice] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const [Thumb, setThumb] = useState(null);
  const [CustomerList, setCustomerList] = useState([]);
  const [isLoading, SetisLoading] = useState(true);
  const [exArray, setExarray] = useState([]);
  const [deleted, setDeleted] = useState([]);
  const [exchanged, setExchanged] = useState([]);
  const [Found, setFound] = useState(false);
  const [FoundCustomer, setFoundCustomer] = useState(false);
  const [selectedDivision, setSelectedDivision] = useState({
    label: "",
    value: "",
  });
  const [selectedDistrict, setSelectedDistrict] = useState({
    label: "",
    value: "",
  });
  const [selectedTown, setSelectedTown] = useState({ label: "", value: "" });
  const [selectLoading, setSelectLoading] = useState(false);
  // pathao
  const [deliveryService, setDeliveryService] = useState({
    label: "Pathao",
    value: 0,
  });
  const [pathaoCity, setPathaoCity] = useState({
    label: "",
    value: "",
  });
  const [pathaoZone, setPathaoZone] = useState({
    label: "",
    value: "",
  });
  const [pathaoArea, setPathaoArea] = useState({
    label: "",
    value: "",
  });

  // Address Form methods start
  const {
    register,
    control,
    watch,
    reset,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    console.log(sInvoice, "found");
    if (Object.keys(sInvoice).length !== 0) {
      if (sInvoice.redex_area_details) {
        reset({
          // division: { label: sInvoice.to_division, value: sInvoice.to_division},
          division: {
            label: sInvoice.redex_division_details.name,
            value: sInvoice.redex_division_details.id,
          },
          // district: { label: sInvoice.to_district, value: sInvoice.to_district},
          district: {
            label: sInvoice.redex_district_details.name,
            value: sInvoice.redex_district_details.id,
          },
          // town: { label: sInvoice.to_city, value: sInvoice.to_city },
          town: {
            label: sInvoice.redex_area_details.name,
            value: sInvoice.redex_area_details.id,
          },
          // zip: { label: sInvoice.to_zip_code, value: sInvoice.to_zip_code }
          zip: sInvoice.to_zip_code,
        });
        setSelectedDivision({
          label: sInvoice.redex_division_details.name,
          value: sInvoice.redex_division_details.id,
        });
        setSelectedDistrict({
          label: sInvoice.redex_district_details.name,
          value: sInvoice.redex_district_details.id,
        });
        setSelectedTown({
          label: sInvoice.redex_area_details.name,
          value: sInvoice.redex_area_details.id,
        });
      } else {
        reset({
          division: { label: sInvoice.to_division, value: "" },
          district: { label: sInvoice.to_district, value: "" },
          town: { label: sInvoice.to_city, value: "" },
          // zip: { label: sInvoice.to_zip_code, value: sInvoice.to_zip_code }
          zip: sInvoice.to_zip_code,
        });
        setSelectedDivision({ label: sInvoice.to_division, value: "" });
        setSelectedDistrict({ label: sInvoice.to_district, value: "" });
        setSelectedTown({ label: sInvoice.to_city, value: "" });
      }
    }
  }, [sInvoice, reset]);
  const [districtList, setDistrictList] = useState([]);
  const [upazillaList, setUpazillaList] = useState([]);
  const [zipList, setZipList] = useState([]);
  const watchFields = watch([
    // "town",
    "division",
    "district",
    "town",
    "zip",
  ]);
  useEffect(() => {
    if (selectedDivision.value !== "") {
      axios
        .get(
          `${BASE_URL}/api/v1/utility/admin/redex-address/${selectedDivision.value}/`
        )
        .then((response) => {
          // setDistrictList(response.data.data.districts)
          if (response.data.data.districts !== undefined) {
            setDistrictList(response.data.data.districts);
          } else {
            setDistrictList([]);
          }
        });
    }
  }, [selectedDivision]);
  useEffect(() => {
    if (selectedDistrict.value !== undefined) {
      const foundAreas = districtList.filter(
        ({ id }) => id == selectedDistrict.value
      )[0]?.areas;
      // setUpazillaList(foundAreas)
      if (foundAreas !== undefined) {
        setUpazillaList(foundAreas);
      } else {
        setUpazillaList([]);
      }
    }
  }, [selectedDistrict, districtList]);
  const handleDivisionChange = (division) => {
    if (selectedDivision?.value !== undefined) {
      console.log(division, "div");
      setSelectedDistrict({ label: "", value: "" });
      setSelectedTown({ label: "", value: "" });
      setValue("zip", "");
      setDistrictList([]);
      setSelectLoading(true);
      setCustomCharge(0);
      setSelectedDivision(division);
      setValue("division", division);
      const selectedDivisionId = division.value;
      axios
        .get(
          `${BASE_URL}/api/v1/utility/admin/redex-address/${selectedDivisionId}/`
        )
        .then((response) => {
          if (response.data.data.districts !== undefined) {
            setDistrictList(response.data.data.districts);
          } else {
            setDistrictList([]);
          }
        });
    }
  };
  const handleDistrictChange = (district) => {
    if (selectedDistrict?.value !== undefined) {
      setSelectedTown({ label: "", value: "" });
      setValue("zip", "");
      setUpazillaList([]);
      setSelectLoading(false);
      setCustomCharge(0);
      setSelectedDistrict(district);
      setValue("district", district);
      const selectedDistrictId = district.value;
      const foundAreas = districtList.filter(
        ({ id }) => id == selectedDistrictId
      )[0]?.areas;
      if (foundAreas !== undefined) {
        setUpazillaList(foundAreas);
      } else {
        setUpazillaList([]);
      }
    }
  };
  const handleTownChange = (town) => {
    if (selectedTown?.value !== undefined) {
      setValue("zip", "");
      setSelectedTown(town);
      setValue("town", town);
      const selectedAreaId = town.value;
      const foundDeliveryCharge = upazillaList?.filter(
        ({ id }) => id == selectedAreaId
      )[0]?.delivery_charge;
      // setCustomCharge(foundDeliveryCharge)
      if (foundDeliveryCharge !== undefined) {
        console.log(foundDeliveryCharge, selectedAreaId, "fdc");
        setCustomCharge(Number(foundDeliveryCharge));
      }
    }
  };
  // useEffect(() => {
  //   console.log(watchFields, "www")
  //   if (watchFields[0]) {
  //     // const foundDistricts = allDistricts.filter(
  //     //   ({ division_id }) => division_id == watchFields[0].value
  //     // );
  //     // setDistrictList(foundDistricts);
  //     const selectedDivisionId = watchFields[0].value
  //     console.log(selectedDivisionId, "ssid")
  //     axios.get(`${BASE_URL}/api/v1/utility/admin/redex-address/${selectedDivisionId}/`).then(response => {
  //       console.log(response.data.data.districts, "dis")
  //       if (response.data.data.districts !== undefined) {
  //         setDistrictList(response.data.data.districts)
  //       } else {
  //         setDistrictList([])
  //       }
  //     })
  //   }
  //   console.log(watchFields[1]?.label, districtList, "div");
  // }, [watchFields[0]?.value]);
  // useEffect(() => {
  //   console.log(districtList, "dist")
  //   if (watchFields[1]?.value !== undefined) {
  //     // const foundUpazillas = upazillas.filter(
  //     //   ({ district_id }) => district_id == watchFields[1].value
  //     // );
  //     // setUpazillaList(foundUpazillas);
  //     const selectedDistrictId = watchFields[1].value
  //     const foundAreas = districtList.filter(({ id }) => id == selectedDistrictId)[0]?.areas;
  //     if (foundAreas !== undefined) {
  //       setUpazillaList(foundAreas)
  //     } else {
  //       setUpazillaList([])
  //     }
  //     console.log(foundAreas, "fff")
  //   }
  //   // if (watchFields[1].label !== )
  // }, [watchFields[1]?.value, districtList]);

  // useEffect(() => {
  //   if (watchFields[2]?.value !== undefined) {
  //     console.log(upazillaList, watchFields[2], "upl")
  //     const selectedAreaId = watchFields[2].value;
  //     const foundDeliveryCharge = upazillaList?.filter(({ id }) => id == selectedAreaId)[0]?.delivery_charge
  //     console.log(foundDeliveryCharge, selectedAreaId, "fdc")
  //     if (foundDeliveryCharge !== undefined) {
  //       setCustomCharge(foundDeliveryCharge)
  //     }
  //   }
  // }, [watchFields[2]?.value, upazillaList])

  // useEffect(() => {
  //   if (watchFields[2]) {
  //     const foundZips = zips.filter(
  //       ({ name, postCode, upazila }) => upazila == watchFields[2].label
  //     );
  //     setZipList(foundZips);
  //   }
  // }, [watchFields[2]]);
  // Address form methods end
  const delivery_charge = {
    0: 80,
    1: 150,
  };
  const options1 = [
    { value: 0, label: "Regular" },
    { value: 1, label: "Urgent" },
  ];

  const deliveryType = [
    { value: 0, label: "Regular" },
    { value: 1, label: "Urgent" },
  ];
  const invoice_choices = [
    { value: 0, label: "Recieved" },
    { value: 1, label: "Pending" },
    { value: 2, label: "Refunded" },
  ];

  const delivery_choices = [
    { value: 0, label: "Returned" },
    { value: 1, label: "Order Placed" },
    { value: 2, label: "Delivered" },
    { value: 3, label: "Pending" },
    { value: 4, label: "Hold" },
    { value: 5, label: "Dispatched" },
  ];
  console.log(delivery_choices);
  const paymentType = [
    { value: 0, label: "Cash On Delivery" },
    { value: 1, label: "Card" },
    { value: 2, label: "Bank Transfer" },
    { value: 3, label: "Bkash" },
    { value: 4, label: "SSLECOMMERZ" },
    { value: 5, label: "Nagad" },
    { value: 6, label: "Kaaruj Delivery" },
  ];

  const deliverypriceChoices = {
    0: "Inside Dhaka : 80/-",
    1: "Outside Dhaka : 150/-",
  };
  const deliveryPrice_options = [
    { value: 0, label: "Inside Dhaka : 80/-" },
    { value: 1, label: "Outside Dhaka : 150/-" },
  ];

  const history = useHistory();

  const [InvoiceAllData, SetInvoiceAllData] = useState({
    invoice_date: sInvoice.invoice_date,
    invoice_due_date: sInvoice.due_date,
    invoice_bill_from: sInvoice.bill_from,
    invoice_bill_to: sInvoice.bill_to,
    invoice_from_mobile: sInvoice.from_mobile,
    invoice_to_mobile: "",
    invoice_from_address: sInvoice.from_address,
    invoice_to_address: sInvoice.to_address,
    invoice_delivery_charge: sInvoice.delivery_charge,
    invoice_notes: sInvoice.notes,
    invoice_to_email: "type",
    invoice_from_email: "type",
    invoice_number: "#INV01221",
    invoice_barcode: "12121212121",
    invoice_to_address2: "",
    to_zip_code: "",
    to_country: "",
    to_district: "",
    to_division: "",
    to_city: "",
  });

  console.log(InvoiceAllData["invoice_to_mobile"], "mobile");

  const [paymentAllData, setPaymentAllData] = useState({
    card_holder_name: "",
    card_number: "",
    bank_name: "",
    banK_account_number: "",
    banK_account_name: "",
    banK_branch_name: "",
    bkash_number: "",
    bkash_trx_number: "",
    nagad_number: "",
    nagad_trx_number: "",
    reference_id: "",
  });

  const clearPaymentALlData = () => {
    setPaymentAllData({
      card_holder_name: "",
      card_number: "",
      card_expiry_date: "",
      bank_name: "",
      banK_account_number: "",
      banK_routing_number: "",
      banK_branch_name: "",
      bkash_number: "",
    });
  };
  const [fromCode, setFromCode] = useState("880");
  const [toCode, setToCode] = useState("880");
  const [mainState, setMainState] = useState({});
  const [mainInnerState, setMainInnerState] = useState({});
  const [pS, setPs] = useState(0);
  const [Jdata, setJData] = useState([]);
  useEffect(() => {
    let temp1 = mainState;
    console.log(temp1, "--------mainState found temp1------");

    var output = [];
    for (let i in temp1) {
      console.log(temp1[i]["variantObj"]);
      for (let j in temp1[i]["variantObj"]) {
        console.log(j);
        console.log(temp1[i]["variantObj"][j]);
        const d = temp1[i]["variantObj"][j];
        d.total !== 0 &&
          output.push({
            name: i,
            basePrice: temp1[i].price,
            thumb: temp1[i].thumb,
            discount: isNaN(temp1[i].discount) === true ? 0 : temp1[i].discount,
            price: d["price"],
            quantity: d["quantity"],
            id: d["id"],
            total: d["total"],
            variant: d["name"],
          });
      }
    }
    setJData(output);
  }, [mainState]);
  const [inputQuery, setInputQuery] = useState("");
  console.log("Jdata", Jdata);
  const [optional, setOptional] = useState("");
  const [URL, setURL] = useState("");
  const [fileName, setFileName] = useState("");
  const [Items, SetItems] = useState([]);
  const [Signature, SetSignature] = useState(null);
  const [pdJson, setPdJson] = useState([]);
  const [invProduct, setInvProduct] = useState([]);

  function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }
  const fileHandle = (e) => {
    SetSignature(e.target.files[0]);

    setFileName(e.target.files[0].name);
    const reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    setURL(reader.result);
    reader.onload = () => {
      if (reader.readyState === 2) {
        setURL(reader.result);
      }
    };
  };
  const handleOptional = (e) => {
    const reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    setOptional(reader.result);
    reader.onload = () => {
      if (reader.readyState === 2) {
        setOptional(reader.result);
      }
    };
  };
  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      color: state.selectProps.menuColor,
    }),
  };

  const convertData = (date) => {
    var current = new Date(date);
    return current.toISOString().substring(0, 10);
  };

  const clearData = () => {
    SetInvoiceAllData({
      invoice_date: "",
      invoice_due_date: "",
      invoice_bill_from: "",
      invoice_bill_to: "",
      invoice_from_mobile: "",
      invoice_to_mobile: "",
      invoice_from_address: "",
      invoice_to_address: "",
      invoice_delivery_charge: "",
      invoice_notes: "",
      barcode: "",
      invoice_to_address2: "",
      to_zip_code: "",
      to_country: "",
      to_district: "",
      to_division: "",
      to_city: "",
    });
  };
  console.log("found-----------", Found);
  console.log("found-----------", FoundCustomer);
  const [ProductsList, setProductsList] = useState([]);
  const [defaultValue, setdefaultValue] = useState([]);
  const [originalInvoiceProducts, setOriginalInvoiceProducts] = useState([]);
  const getProductList = () => {
    if (inputQuery?.length > 1) {
      const url = inputQuery
        ? `${BASE_URL}/api/v1/inventory/inventory/product_list_for_invoice_pagination/?query=${inputQuery}&limit=20`
        : `${BASE_URL}/api/v1/inventory/inventory/product_list_for_invoice_pagination/`;

      axios
        .get(url)
        .then((res) => {
          const { results } = res.data.data;

          // Create variant-based options instead of product-based
          const variantOptions = [];
          results.forEach((product) => {
            product.variants.forEach((variant) => {
              variantOptions.push({
                label: `${product.name} [${product.sku ?? ""}] - ${
                  variant.name
                } [[${variant.sku}]]`,
                value: variant.id,
                price: variant.calculated_price,
                discount: 0,
                stock: variant.stock,
                product_id: product.id,
                product_name: product.name,
                product_sku: product.sku,
                variant_name: variant.name,
                variant_sku: variant.sku,
                thumb: product.thumb_url || product.thumb,
                main_price: 0,
                main_discount: 0,
                image: `${
                  product?.thumb_resized_url
                    ? product.thumb_resized_url
                    : `${BASE_URL}media/default/lazy_placeholder.jpg`
                }`,
              });
            });
          });

          setProductsList(variantOptions);
        })
        .catch((err) => {
          const message = JSON.parse(err.request.response).message;
          // console.log(err.request.response);
        });
    }
  };
  console.log("ProductsList", ProductsList);

  // console.log(InvoiceAllData["invoice_date"]);
  // function transformData(inputData) {
  //   const transformedData = {};

  //   for (const key in inputData) {
  //     const variantDetails = inputData[key][0].variant_details;

  //     transformedData[key] = inputData[key].map((item) => ({
  //       label: variantDetails.name,
  //       value: item.variant,
  //       price: variantDetails.price,
  //       stock: variantDetails.stock,
  //       quantity: 1,
  //     }));
  //   }

  //   return transformedData;
  // }
  function transformData(products) {
    return products.reduce((result, product) => {
      const uniqueKey = `${product.product_name}_${product.variant_name}_${product.variant}`;
      const variantData = {
        label: product.variant_name,
        value: product.variant,
        price: product.variantObj.price,
        stock: product.variantObj.stock,
        quantity: product.quantity,
      };

      if (!result[uniqueKey]) {
        result[uniqueKey] = [];
      }

      result[uniqueKey].push(variantData);
      return result;
    }, {});
  }

  const formatInvoiceProducts = (products) => {
    const result = {};

    products.forEach((item) => {
      // Create unique key for each variant to handle multiple variants of same product
      const productSkuKey = item.sku;
      const variantSkuKey = item.variantObj?.sku;
      const uniqueKey =
        productSkuKey && variantSkuKey
          ? `${productSkuKey}_${item.variant_name}_${variantSkuKey}`
          : `${item.product_name}_${item.variant_name}`;

      if (!result[uniqueKey]) {
        result[uniqueKey] = {
          id: item.product,
          variant: [],
          variantObj: {},
          stock: item.variantObj.stock,
          thumb: item.thumb, // Use thumb directly without replacing _optimized
          discount: parseFloat(item.discount_value) || 0,
          productName: item.product_name, // Store original product name
          productSku: item.sku, // Store SKU
          offer_price: parseFloat(item.offer_price || 0), // Store offer_price for reference
        };
      }

      // Use ONLY calculated_price from variantObj - it's the full and final price per unit
      // Prioritize offer_price if available, otherwise use calculated_price
      const variantPrice = item.offer_price
        ? parseFloat(item.offer_price)
        : parseFloat(item.variantObj?.calculated_price || 0);

      // Calculate total: use offer_price if available, otherwise calculated_price * quantity
      let calculatedTotal = parseFloat(item.total);
      if (variantPrice > 0 && parseFloat(item.quantity) > 0) {
        calculatedTotal = variantPrice * parseFloat(item.quantity);
      }

      const variant = {
        id: item.variant,
        name: item.variant_name,
        price: variantPrice, // Use ONLY calculated_price (or offer_price) - it's the final price
        stock: item.variantObj.stock,
        sku: item.variantObj?.sku || "",
        quantity: item.quantity.toString(),
        total: calculatedTotal,
        offer_price: parseFloat(item.offer_price || 0),
        calculated_price: parseFloat(item.variantObj?.calculated_price || 0), // Store calculated_price (final price)
      };

      // Each entry has only one variant
      result[uniqueKey].variant = [variant];
      // Store variant in variantObj with calculated_price (final price)
      result[uniqueKey].variantObj[item.variant_name] = {
        ...variant,
        offer_price: parseFloat(item.offer_price || 0),
        calculated_price: parseFloat(item.variantObj?.calculated_price || 0), // Store calculated_price (final price)
      };
    });
    return result;
  };

  const getDeletedInvoiceProducts = () => {
    if (!originalInvoiceProducts || originalInvoiceProducts.length === 0) {
      return [];
    }

    // Create a map of unique keys from original invoice products
    const originalKeysMap = new Map();
    originalInvoiceProducts.forEach((item) => {
      const productSkuKey = item.sku;
      const variantSkuKey = item.variantObj?.sku;
      const uniqueKey =
        productSkuKey && variantSkuKey
          ? `${productSkuKey}_${item.variant_name}_${variantSkuKey}`
          : `${item.product_name}_${item.variant_name}`;

      // Store the invoice product ID with the unique key
      if (!originalKeysMap.has(uniqueKey)) {
        originalKeysMap.set(uniqueKey, []);
      }
      originalKeysMap.get(uniqueKey).push(item.id);
    });

    // Get current mainState keys
    const currentKeys = new Set(Object.keys(mainState));

    // Find deleted variants (exist in original but not in current)
    const deletedIds = [];
    originalKeysMap.forEach((ids, uniqueKey) => {
      if (!currentKeys.has(uniqueKey)) {
        // This variant was deleted, add all its IDs
        deletedIds.push(...ids);
      }
    });

    if (deletedIds.length > 0) {
      console.log("Deleted variants:", deletedIds);
    }

    return deletedIds;
  };
  const getInvoice = () => {
    let url = `${BASE_URL}api/v1/sales/inventory/invoice/${id}`;
    axios
      .get(url, url)
      .then((res) => {
        if (res.data.status) {
          // showToast("success", "Invoice Created.");

          setSInvoice(res.data.data);
          setExchanged(res.data.data.invoice_products);
          SetInvoiceAllData({
            invoice_date: res.data.data.invoice_date,
            invoice_due_date: res.data.data.due_date,
            invoice_bill_from: res.data.data.bill_from,
            invoice_bill_to: res.data.data.bill_to,
            invoice_from_mobile:
              res.data.data.from_mobile !== undefined &&
              res.data.data.from_mobile.replace("+880", ""),
            invoice_to_mobile:
              res.data.data.to_mobile !== undefined &&
              (() => {
                const mobile = res.data.data.to_mobile.replace("+880", "");
                return mobile.startsWith("0") ? mobile.substring(1) : mobile;
              })(),
            invoice_from_address: res.data.data.from_address,
            invoice_to_address: res.data.data.to_address,
            invoice_to_address2: res.data.data.to_address2,
            to_zip_code: res.data.data.to_zip_code,
            to_country: res.data.data.to_country,
            to_district: res.data.data.to_district,
            to_division: res.data.data.to_division,
            to_city: res.data.data.to_city,
            invoice_delivery_charge: res.data.data.delivery_charge_type,
            invoice_delivery_status: res.data.data.delivery_status,
            invoice_payment_status: res.data.data.payment_status,
            invoice_notes: res.data.data.notes,
            invoice_to_email: res.data?.data?.to_email,
            invoice_from_email: res.data?.data?.from_email,
            invoice_number: res?.data?.data?.number,
            invoice_barcode: res?.data?.data?.barcode_text,
            barcode: res?.data?.data?.barcode,
          });
          SetSignature(res.data?.data?.signature);
          setURL(res.data?.data?.signature);
          setpaid(res.data?.data?.total_paid);
          setDiscount(res.data?.data?.total_discount);
          setinvoice_discount_type(res.data?.data?.discount_type);
          setinvoice_payment_type(res.data?.data?.payment_type);
          const dataJson = JSON.parse(res.data.data.product_list_json);
          // setMainState(dataJson?.mainstate);
          // console.log(dataJson, "dddd");
          const formattedProducts = formatInvoiceProducts(
            res.data.data.invoice_products
          );
          setMainState(formattedProducts);
          setMainInnerState(transformData(res.data?.data?.invoice_products));
          // Store original invoice products for comparison
          setOriginalInvoiceProducts(res.data.data.invoice_products || []);

          // Set defaultValue for the select component
          const defaultValues = Object.keys(formattedProducts).map(
            (key, index) => {
              const product = formattedProducts[key];
              const variant = product.variant[0];
              return {
                value: variant.id,
                label: `${product.productName} [${product.productSku}] - ${
                  variant.name
                } [[${variant.sku || ""}]]`,
                product_id: product.id,
                product_name: product.productName,
                product_sku: product.productSku,
                variant_name: variant.name,
                variant_sku: variant.sku || "",
              };
            }
          );
          setdefaultValue(defaultValues);

          setPdJson(JSON.parse(res.data.data?.invoice_view_json));
          console.log(JSON.parse(res.data.data?.invoice_view_json), "dddd");
          setinvoice_delivery_type(res.data?.data?.delivery_type);
          // res.data?.data?.discount_type === 0 ? setDiscount(res.data?.data?.flat_discount) : setDiscount(res.data?.data?.percent_discount);
          setDelivrey_status(res.data?.data?.delivery_status);
          setinvoice_status(res.data?.data?.payment_status);
          setinvoice_delivery_charge(res.data?.data?.delivery_charge_type);
          setCustomCharge(Number(res.data?.data?.delivery_charge));
          setCustomPrice(Number(res.data?.data?.custom_price) || 0);

          setInvProduct(res?.data?.data?.invoice_products);

          setPaymentAllData({
            card_holder_name: res.data?.data?.card_holder_name,
            card_number: res.data?.data?.card_number,
            bank_name: res.data?.data?.bank_name,
            banK_account_number: res.data?.data?.banK_account_number,
            banK_account_name: res.data?.data?.banK_account_name,
            banK_branch_name: res.data?.data?.banK_branch_name,
            bkash_number: res.data?.data?.bkash_number,
            bkash_trx_number: res.data?.data?.bkash_trx_number,
            nagad_number: res.data?.data?.nagad_number,
            nagad_trx_number: res.data?.data?.nagad_trx_number,
            reference_id: res.data?.data?.reference_id,
          });
          console.log(res.data.data.product_list_json);
          setDeliveryService(
            res.data.data.delivery_service === 0
              ? {
                  label: "Pathao",
                  value: 0,
                }
              : {
                  label: "Others",
                  value: 1,
                }
          );
          setPathaoCity({
            label: res.data.data.pathao_city_name
              ? res.data.data.pathao_city_name
              : "",
            value:
              res.data.data.pathao_city_id === 0
                ? ""
                : res.data.data.pathao_city_id,
          });

          setPathaoZone({
            label: res.data.data.pathao_zone_name
              ? res.data.data.pathao_zone_name
              : "",
            value:
              res.data.data.pathao_zone_id === 0
                ? ""
                : res.data.data.pathao_zone_id,
          });

          setPathaoArea({
            label: res.data.data.pathao_area_name
              ? res.data.data.pathao_area_name
              : "",
            value:
              res.data.data.pathao_area_id === 0
                ? ""
                : res.data.data.pathao_area_id,
          });
          SetisLoading(false);
        }
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        const errorMsg = JSON.parse(err.request.response).errors;
        console.log(errorMsg);
        // for (let value of Object.values(errorMsg)) {
        //   showToast("error", value[0]);
        // }

        for (let key in errorMsg) {
          showToast("error", `${key} : ${errorMsg[key][0]}`);
        }
        showToast("error", message);
      });
  };
  useEffect(() => {
    getProductList();
  }, [inputQuery]);
  useEffect(() => {
    getInvoice();
  }, []);

  const inputProduct = (inputValue) => {
    setInputQuery(inputValue);
    console.log("searched", inputQuery);
  };

  console.log("mainState", mainState);

  console.log(mainInnerState, "fromweb inv");

  const [invoice_status, setinvoice_status] = useState(0);
  const [Delivery_status, setDelivrey_status] = useState(0);
  const [invoice_delivery_type, setinvoice_delivery_type] = useState(0);
  const [invoice_payment_type, setinvoice_payment_type] = useState(0);
  const [invoice_delivery_charge, setinvoice_delivery_charge] = useState(2);
  const [invoice_discount_type, setinvoice_discount_type] = useState(0);

  console.log(pdJson, "pdjson");
  console.log(sInvoice?.invoice_products_formatted, "pdjson-new");

  const [InvoiceBelowData, SetInvoiceBelowData] = useState({
    invoice_vat: 0,
    invoice_tax: 0,
    invoice_due: 0,
    invoice_paid: 0,
    invoice_total: 0,
  });
  const ValidateData = (sendEmail) => {
    const bd = /^[1][0-9]{9}$/;
    if (InvoiceAllData["invoice_date"] === "") {
      showToast("error", "Issue  Date can't be empty..");
      return 0;
    } else if (
      !bd.test(InvoiceAllData["invoice_from_mobile"]?.replace("+880", ""))
    ) {
      showToast("error", "From Mobile : Please Enter Valid phone number");
      return 0;
    } else if (
      !bd.test(InvoiceAllData["invoice_to_mobile"]?.replace("+880", ""))
    ) {
      showToast("error", "To Mobile : Please Enter Valid phone number");
      return 0;
    } else if (!Found && InvoiceAllData["invoice_bill_from"] === "") {
      showToast("error", "Bill from  can't be empty..");
      return 0;
    } else if (!Found && InvoiceAllData["invoice_bill_to"] === "") {
      showToast("error", "Bill to  can't be empty..");
      return 0;
    } else if (!Found && InvoiceAllData["invoice_bill_to"] === "") {
      showToast("error", "Bill to  can't be empty..");
      return 0;
    }

    if (InvoiceAllData["invoice_from_email"] === "") {
      showToast("error", "From email  can't be empty..");
      return 0;
    } else if (!validateEmail(InvoiceAllData["invoice_from_email"])) {
      showToast("error", "From email  not valid..");
      return 0;
    } else if (
      Found &&
      !validateEmail(FoundCustomer?.email) === "" &&
      InvoiceAllData["invoice_to_email"].length > 0
    ) {
      showToast("error", "To email  not valid...");
      return 0;
    }
    // else if (
    //   !Found
    //   && !validateEmail(InvoiceAllData["invoice_to_email"])
    //   &&
    //   InvoiceAllData["invoice_to_email"].length > 0
    // ) {
    //   showToast("error", "To email  not valid..");
    //   return 0;
    // }
    if (
      (!Found && InvoiceAllData["invoice_to_address"] === "") ||
      InvoiceAllData["invoice_to_address"]?.length < 11
    ) {
      showToast("error", "To address  can't be less then 10 characters..");
      return 0;
    }

    if (Object.keys(mainState).length <= 0) {
      showToast("error", "Product Details is empty..");
      return 0;
    }
    function isEmpty(obj) {
      return Object.keys(obj).length === 0;
    }

    // if (InvoiceAllData["invoice_notes"] === null) {
    //   showToast("error", "Notes is empty..");
    //   return 0;
    // }

    postInvoice(sendEmail);
  };

  const allvariants = Object?.values(mainState).map(
    (current) => current["variantObj"]
  );
  console.log("allvariants----------", {
    allv: allvariants,
    mins: mainState,
  });

  const postInvoiceAPi = (invoiceProductId, data) => {
    const URLINvoice = `${BASE_URL}api/v1/sales/inventory/invoice-products/${invoiceProductId}/`;

    axios
      .patch(URLINvoice, data)
      .then((res) => {
        if (res.data.status) {
          // clearData();
        }
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        const errorMsg = JSON.parse(err.request.response).errors;
        for (let key in errorMsg) {
          showToast("error", `${key} : ${errorMsg[key][0]}`);
        }
        showToast("error", message);
      });
  };
  const getInvoiceIdAndPost = async (invoiceid, variant_name, data) => {
    const invoiceGetID = `${BASE_URL}api/v1/sales/inventory/invoice-product-id/`;
    const dataProduct = new FormData();
    dataProduct.append("invoice", invoiceid);
    dataProduct.append("variant", variant_name);
    await axios
      .post(invoiceGetID, dataProduct)
      .then((res) => {
        if (res.data.status) {
          console.log("res", res);
          postInvoiceAPi(res.data.data.id, data);
        }
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        const errorMsg = JSON.parse(err.request.response).errors;
        for (let key in errorMsg) {
          showToast("error", `${key} : ${errorMsg[key][0]}`);
        }
        showToast("error", message);
      });
  };
  const postInvoiceProduct = () => {
    console.log("in post invoice");
    const url = `${BASE_URL}api/v1/sales/inventory/invoice-products/`;
    const allvariants = Object.values(mainState).map(
      (current) => current["variantObj"]
    );
    console.log("allvariants", allvariants);
    var dataForUpdate = [];

    for (let items in allvariants) {
      const itemsList = Object.values(allvariants[items]);
      for (let currentitem in itemsList) {
        if (parseInt(itemsList[currentitem]["quantity"]) > 0) {
          var postinfo = {
            price: parseInt(itemsList[currentitem]["price"]),
            quantity: parseInt(itemsList[currentitem]["quantity"]),
            // // data.append("vat", parseInt(mainState[item]["in_vat"]));
            total: parseInt(itemsList[currentitem]["total"]),
            product: parseInt(itemsList[currentitem]["product"]),
            variant: parseInt(itemsList[currentitem]["id"]),
            inv_product_id: parseInt(itemsList[currentitem]["inv_product_id"]),
            invoice: id,
          };
          dataForUpdate.push(postinfo);
        }
      }
    }
    console.log("dataForUpdate", dataForUpdate);

    axios
      .patch(url, { data: dataForUpdate })
      .then((res) => {
        // clearData();
        SetisLoading(false);
        showToast("success", "Invoice Updated.");
        history.push(path.invoice_list);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        const errorMsg = JSON.parse(err.request.response).errors;
        console.log(errorMsg);

        for (let key in errorMsg) {
          showToast("error", `${key} : ${errorMsg[key][0]}`);
        }
        showToast("error", message);
      });
  };

  const [is_send_email, set_is_send_email] = useState(false);
  // const SaveAndSendEmail =
  const SaveAndSendEmail = () => {
    ValidateData(true);
  };
  function findIdByName(param) {
    for (let i = 0; i < pdJson.length; i++) {
      if (pdJson[i].name === param) {
        return pdJson[i].id;
      }
    }
    return null;
  }
  function formatInv(inputData) {
    const formattedData = [];
    for (const key in inputData) {
      const product = inputData[key];
      product.variant?.forEach((variant) => {
        if (parseInt(variant.quantity) >= 0) {
          const existingInvoiceProductId = originalInvoiceProducts?.find(
            (item) => item.product === product.id && item.variant === variant.id
          )?.id;
          formattedData.push({
            quantity: variant.quantity,
            total: variant.total.toString(),
            product_name: product.productName || key.split("_")[0], // Use stored product name
            variant_name: variant.name,
            is_custom: false,
            created_at: new Date(),
            invoice_date: InvoiceAllData["invoice_date"],
            product: product.id,
            variant: variant.id,
            id: existingInvoiceProductId,
            is_regular: true,
          });
        }
      });
    }
    return formattedData;
  }
  function findMatchingUniqueIds(arr1, arr2) {
    const matchingIds = new Set();

    arr1.forEach((item) => {
      if (arr2.includes(item.product_name)) {
        matchingIds.add(item.id);
      }
    });

    return Array.from(matchingIds);
  }
  useEffect(() => {
    const data = findMatchingUniqueIds(exchanged, deleted);
    setExarray(data);
  }, [mainState]);
  console.log(mainState, "vd");
  const postInvoice = (sendEmail) => {
    const url = `${BASE_URL}api/v1/sales/inventory/invoice/${id}/`;
    const data = new FormData();
    const toMobile = `+${toCode}${InvoiceAllData["invoice_to_mobile"]}`;
    const fromMobile = `+${toCode}${InvoiceAllData["invoice_from_mobile"]}`;

    const current_user = JSON.parse(localStorage.getItem("userData"));

    // Get deleted invoice products
    const deletedInvoiceProducts = getDeletedInvoiceProducts();
    data.append(
      "invoice_date",
      InvoiceAllData["invoice_date"] !== "" &&
        convertData(InvoiceAllData["invoice_date"])
    );

    data.append("bill_from", InvoiceAllData["invoice_bill_from"]);
    data.append("bill_to", InvoiceAllData["invoice_bill_to"]);
    data.append("from_mobile", fromMobile);
    data.append("to_mobile", toMobile);
    data.append("to_email", InvoiceAllData["invoice_to_email"]);
    data.append("from_address", InvoiceAllData["invoice_from_address"]);
    data.append(
      "to_address",
      Found ? FoundCustomer.address : InvoiceAllData["invoice_to_address"]
    );
    data.append(
      "delivery_charge",
      parseInt(invoice_delivery_charge) === 2
        ? customCharge
        : delivery_charge[invoice_delivery_charge]
    );

    data.append("delivery_charge_type", parseInt(invoice_delivery_charge));
    data.append("delivery_status", Delivery_status);
    data.append("delivery_type", invoice_delivery_type);
    data.append("discount_type", invoice_discount_type);
    data.append("total_discount", Discount);
    data.append("payment_type", invoice_payment_type);
    data.append("card_holder_name", paymentAllData["card_holder_name"]);
    data.append("card_number", paymentAllData["card_number"]);
    data.append("card_expiry_date", paymentAllData["card_expiry_date"]);
    data.append("bank_name", paymentAllData["bank_name"]);
    data.append("banK_account_number", paymentAllData["banK_account_number"]);
    data.append("banK_account_name", paymentAllData["banK_account_name"]);
    data.append("banK_branch_name", paymentAllData["banK_branch_name"]);
    data.append("bkash_number", paymentAllData["bkash_number"]);
    data.append("bkash_trx_number", paymentAllData["bkash_trx_number"]);

    data.append("payment_type", invoice_payment_type);
    data.append("payment_status", invoice_status);
    data.append("total_due", parseInt(getDueAmount()));
    data.append("total_paid", paid);
    data.append("total_amount", parseInt(getGrandTotal()));
    data.append("total_vat", 0);
    data.append("notes", InvoiceAllData["invoice_notes"]);
    data.append("created_by", current_user.id);
    data.append("total_discount", Discount);
    data.append("send_pdf", sendEmail);
    data.append("discount_type", invoice_discount_type);
    data.append(
      "product_list_json",
      JSON.stringify({
        mainstate: mainState,
        maininnerstate: mainInnerState,
      })
    );
    data.append("invoice_view_json", JSON.stringify(Jdata));
    SetisLoading(true);
    const dataObj = {
      invoice_date:
        InvoiceAllData["invoice_date"] !== "" &&
        convertData(InvoiceAllData["invoice_date"]),
      bill_from: InvoiceAllData["invoice_bill_from"],
      bill_to: InvoiceAllData["invoice_bill_to"],
      from_mobile: fromMobile,
      to_mobile: toMobile,
      to_email: InvoiceAllData["invoice_to_email"],
      from_address: InvoiceAllData["invoice_from_address"],
      to_address: Found
        ? FoundCustomer.address
        : InvoiceAllData["invoice_to_address"],
      delivery_charge:
        parseInt(invoice_delivery_charge) === 2
          ? customCharge
          : delivery_charge[invoice_delivery_charge],
      delivery_charge_type: parseInt(invoice_delivery_charge),
      delivery_status: Delivery_status,
      delivery_type: invoice_delivery_type,
      discount_type: invoice_discount_type,
      total_discount: Discount,
      payment_type: invoice_payment_type,
      card_holder_name: paymentAllData["card_holder_name"],
      card_number: paymentAllData["card_number"],
      card_expiry_date: paymentAllData["card_expiry_date"],
      bank_name: paymentAllData["bank_name"],
      banK_account_number: paymentAllData["banK_account_number"],
      banK_account_name: paymentAllData["banK_account_name"],
      banK_branch_name: paymentAllData["banK_branch_name"],
      bkash_number: paymentAllData["bkash_number"],
      bkash_trx_number: paymentAllData["bkash_trx_number"],
      nagad_number: paymentAllData["nagad_number"],
      nagad_trx_number: paymentAllData["nagad_trx_number"],
      reference_id: paymentAllData["reference_id"],
      payment_status: invoice_status,
      total_due: parseInt(getDueAmount()),
      total_paid: paid,
      total_amount: parseInt(getGrandTotal()),
      custom_price: Number(customPrice) || 0,
      sub_total: isNaN(getSubTotal()) ? 0 : getSubTotal(),
      total_vat: 0,
      notes: InvoiceAllData["invoice_notes"],
      created_by: current_user.id,
      send_pdf: sendEmail,
      product_list_json: JSON.stringify({
        mainstate: mainState,
        maininnerstate: mainInnerState,
      }),
      invoice_view_json: JSON.stringify(Jdata),
      invoice_products_details: formatInv(mainState),
      to_address2: Found
        ? FoundCustomer.to_address2
        : InvoiceAllData["invoice_to_address2"],
      to_country: Found
        ? FoundCustomer.to_country
        : InvoiceAllData["to_country"],
      to_district: Found ? FoundCustomer.to_district : watchFields[1]?.label,
      to_division: Found ? FoundCustomer.to_division : watchFields[0]?.label,
      to_zip_code: Found ? FoundCustomer.to_zip_code : watchFields[3],
      to_city: Found ? FoundCustomer.to_city : watchFields[2]?.label,
      exchange_products_json: {
        data: exArray,
      },
      deleted_invoice_products: deletedInvoiceProducts,
      is_regular: true,
      redex_division: watchFields[0]?.value,
      redex_district: watchFields[1]?.value,
      redex_area: watchFields[2]?.value,
      // pathao data
      delivery_service: deliveryService.value,
      pathao_city_name: pathaoCity.label ? pathaoCity.label : "",
      pathao_city_id: pathaoCity.value ? pathaoCity.value : 0,
      pathao_zone_name: pathaoZone.label ? pathaoZone.label : "",
      pathao_zone_id: pathaoZone.value ? pathaoZone.value : 0,
      pathao_area_name: pathaoArea.label ? pathaoArea.label : "",
      pathao_area_id: pathaoArea.value ? pathaoArea.value : 0,
    };

    axios
      .patch(url, dataObj)
      .then((res) => {
        // postInvoiceProduct();
        SetisLoading(false);
        showToast("success", "Invoice Updated.");
        history.push(path.invoice_list);

        // }
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        const errorMsg = JSON.parse(err.request.response).errors;
        console.log(errorMsg);
        // for (let value of Object.values(errorMsg)) {
        //   showToast("error", value[0]);
        // }

        for (let key in errorMsg) {
          showToast("error", `${key} : ${errorMsg[key][0]}`);
        }
        showToast("error", message);
      });
  };
  console.log(InvoiceAllData, "iData");

  console.log("mainstate format", formatInv(mainState));

  // const getCustomerList = () => {
  //   const url = `${BASE_URL}api/v1/inventory/inventory/customer/`;

  //   axios
  //     .get(url)
  //     .then((res) => {
  //       const result = res.data.data.results;
  //       setCustomerList(result);
  //     })
  //     .catch((err) => {
  //       const message = JSON.parse(err.request.response).message;
  //       // console.log(err.request.response);
  //       if (
  //         message === "Invalid token." ||
  //         JSON.parse(err.request.response).code === 401
  //       ) {
  //         // history.push('/login')
  //         logout_func2(setOnlogoutHide, history);
  //       }
  //     });
  // };
  const removeImg = () => {
    swal({
      title: "Are you sure?",
      text: "Once Removed, you will not be able to recover this  file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setURL("");
        setFileName("");
        swal("Poof! Your  file has been Removed!", {
          icon: "success",
        });
      } else {
        swal("Your  file is safe!");
      }
    });
  };
  const print = useRef();
  console.log("mainStateRakib", mainState);
  const HandleNewProductsInputValue = (e, product_name) => {
    let name = e.target.name;
    let value = parseInt(e.target.value);
    setMainState({
      ...mainState,
      [product_name]: { ...mainState[product_name], [name]: value },
    });
  };

  console.log(mainState, "formated web invoice");

  useEffect(() => {
    Object.keys(ProductsList).map((curr, index) => {
      setMainState({
        ...mainState,
        [curr]: { ...mainState[curr], in_price: ProductsList[index]["price"] },
      });
    });
    // getCustomerList();
  }, []);
  const toPhoneHandle = (e) => {
    let value = `+${toCode}${e.target.value}`;

    // handleInputs(e, SetInvoiceAllData);
    // Object.values(CustomerList).map((curr) => {
    //   console.log("curr.mobile", curr.mobile);
    //   console.log("value", value);
    //   if (curr.mobile === value) {
    //     setFound(true);
    //     setFoundCustomer(curr);
    //     showToast("success", "Found Customer");
    //   }
    //   // else {
    //   //   setFound(false);
    //   // }
    // });
    for (let item in CustomerList) {
      console.log("item", item);
      console.log("item", CustomerList[item]);
      if (CustomerList[item]["mobile"] === value) {
        setFound(true);
        setFoundCustomer(CustomerList[item]);
        showToast("success", "Found Customer");
        break;
      } else if (CustomerList[item]["mobile"] !== value) {
        setFound(false);
      }
    }
  };
  const [paid, setpaid] = useState(0);
  const [Discount, setDiscount] = useState(0);
  const getTotal = (curr, innerCur) => {
    return (
      Object.keys(mainState).length > 0 &&
      mainState !== undefined &&
      mainState[curr] !== undefined &&
      mainState[curr]["variant"]["total"]
    );
    // return Object.keys(mainState).length > 0 && mainState !== undefined && mainState[curr] !== undefined && mainState[curr]["variant"]["total"];
  };

  const getSubTotal = () => {
    const allarray = Object.values(mainState).map((curr) => {
      if (curr.variant && curr.variant.length > 0) {
        return parseInt(curr.variant[0].total) || 0;
      }
      return 0;
    });
    return allarray.reduce((a, b) => a + b, 0);
  };

  const getFlatDiscount = () => {
    return Discount;
  };
  const getDeliveryCharge = () => {
    if (parseInt(invoice_delivery_charge) === 2) {
      return customCharge;
    } else {
      return delivery_charge[invoice_delivery_charge];
    }
  };
  // prev 16april 2024
  // const getPercentageDiscount = () => {
  //   let total =
  //     getSubTotal() + invoice_delivery_charge !== 2
  //       ? getDeliveryCharge()
  //       : customCharge;
  //   return parseInt((Discount / 100) * total);
  // };

  // new 16april 2024
  const getPercentageDiscount = () => {
    let total = getSubTotal();
    return parseInt((Discount / 100) * total);
  };

  const getBasePlusVariant = (curr, variant) => {
    // Use ONLY calculated_price from variant - it's the full and final price per unit
    // Prioritize offer_price if available, otherwise use calculated_price
    if (variant.offer_price && variant.offer_price > 0) {
      return parseInt(variant.offer_price);
    }

    // calculated_price is the final price from variantObj (e.g., 950) - use it directly
    if (variant.calculated_price && variant.calculated_price > 0) {
      return parseInt(variant.calculated_price);
    }

    // Fallback: use variant.price which should already be set to calculated_price
    if (variant.price && variant.price > 0) {
      return parseInt(variant.price);
    }

    return 0;
  };

  const getGrandTotal = () => {
    const discountCalc =
      invoice_discount_type === 0 || invoice_discount_type === "0"
        ? getFlatDiscount()
        : getPercentageDiscount();
    const charge =
      parseInt(invoice_delivery_charge) !== 2
        ? parseInt(getDeliveryCharge())
        : parseInt(customCharge);
    const ssl = sInvoice?.has_ssl_offer ? sInvoice.ssl_discount_amount : 0;
    const grand =
      getSubTotal() + charge + (Number(customPrice) || 0) - discountCalc - ssl;
    return grand < 0 ? 0 : parseInt(grand - sInvoice?.redeem_point);
  };

  const getDueAmount = () => {
    const due = getGrandTotal() - paid;
    return due < 0 ? 0 : due;
  };
  const handleMultiInputChange = (newValue, actionMeta) => {
    if (actionMeta.action === "select-option") {
      const option = actionMeta.option;
      const productName = option.product_name;
      const variantName = option.variant_name;
      const productSku =
        option.product_sku || option.productSKU || option.product_sku_code;
      const variantSku = option.variant_sku;
      const uniqueKey =
        productSku && variantSku
          ? `${productSku}_${variantName}_${variantSku}`
          : `${productName}_${variantName}`;

      // Check if this specific variant already exists
      if (mainState[uniqueKey]) {
        console.log("Variant already exists, skipping");
        return;
      }

      // Create new variant entry with unique key
      const newVariant = {
        id: option.value,
        name: variantName,
        price: option.price,
        stock: option.stock,
        product: option.product_id,
        quantity: -1,
        total: 0,
      };

      const variantsObj = {
        [variantName]: newVariant,
      };

      setMainState((prevMainState) => ({
        ...prevMainState,
        [uniqueKey]: {
          id: option.product_id,
          variant: [newVariant],
          variantObj: variantsObj,
          price: parseInt(option.main_price),
          stock: parseInt(option.stock),
          thumb: option.thumb,
          discount: parseInt(option.main_discount),
          productName: productName,
          productSku: productSku,
        },
      }));

      // Add to defaultValue
      setdefaultValue((prevDefaultValue) => {
        return [
          ...prevDefaultValue,
          {
            value: option.value,
            label: option.label,
          },
        ];
      });
    }

    if (actionMeta.action === "remove-value") {
      const removedOption = actionMeta.removedValue;

      if (removedOption) {
        const productSku =
          removedOption.product_sku ||
          removedOption.productSKU ||
          removedOption.product_sku_code;
        const variantSku = removedOption.variant_sku;
        const variantName = removedOption.variant_name;
        let uniqueKey;

        if (productSku && variantSku && variantName) {
          uniqueKey = `${productSku}_${variantName}_${variantSku}`;
        } else if (removedOption.label) {
          // Parse from label format
          const label = removedOption.label;
          const parts = label.split(" - ");
          if (parts.length >= 2) {
            const left = parts[0];
            const right = parts[1];
            const productSkuMatch = left.match(/\[(.*?)\]$/);
            const parsedProductSku = productSkuMatch
              ? productSkuMatch[1]
              : undefined;
            const parsedVariantName = right.split(" [[")[0];
            const variantSkuMatch = right.match(/\[\[(.*?)\]\]/);
            const parsedVariantSku = variantSkuMatch
              ? variantSkuMatch[1]
              : undefined;

            if (parsedProductSku && parsedVariantName && parsedVariantSku) {
              uniqueKey = `${parsedProductSku}_${parsedVariantName}_${parsedVariantSku}`;
            } else {
              uniqueKey = `${parts[0]}_${parsedVariantName}`;
            }
          }
        }

        if (uniqueKey && mainState[uniqueKey]) {
          setDeleted((prev) => [...prev, uniqueKey]);
          setMainState((prev) => {
            const newState = { ...prev };
            delete newState[uniqueKey];
            return newState;
          });
        }
      }

      setdefaultValue((prevDefaultValue) =>
        prevDefaultValue.filter(
          (value) =>
            value.label !== actionMeta.removedValue.label &&
            value.value !== actionMeta.removedValue.value
        )
      );
    }
  };
  // useEffect(() => {
  //   Object.keys(ProductsList).map((curr, index) => {
  //     setMainState({
  //       ...mainState,
  //       [curr]: { ...mainState[curr], in_price: ProductsList[index]["price"] },
  //     });
  //   });
  // }, []);
  const handlePrint = useReactToPrint({
    content: () => print.current,
    documentTitle: "emp-data",
    bodyClass: "dis",
  });
  const handlePrint2 = () => {
    if (
      InvoiceAllData["invoice_from_email"] !== "" ||
      InvoiceAllData["invoice_to_email"] ||
      InvoiceAllData["invoice_bill_to"] ||
      InvoiceAllData["invoice_bill_form"]
    ) {
      handlePrint();
    } else {
      swal("error");
    }
  };

  const handleQuantity = (e, curr, variant) => {
    const uniqueKey = curr;
    const variantName = variant.name;

    if (e.target.value < 0) {
      setPs(0);
    } else {
      setPs(e.target.value);
    }

    setMainState((prevInputs) => {
      const copiedObjects = Object.assign({}, mainState);

      if (parseInt(e.target.value) < 0) {
        copiedObjects[uniqueKey]["variant"][0]["quantity"] = 0;
        copiedObjects[uniqueKey]["variantObj"][variantName]["quantity"] = 0;
      } else if (parseInt(e.target.value) > variant.stock) {
        showToast("error", `Max Stock : ${variant.stock}`);
        copiedObjects[uniqueKey]["variant"][0]["quantity"] = 0;
        copiedObjects[uniqueKey]["variantObj"][variantName]["quantity"] = 0;
        copiedObjects[uniqueKey]["variant"][0]["quantity"] = variant.stock;
        copiedObjects[uniqueKey]["variantObj"][variantName]["quantity"] =
          variant.stock;
      } else {
        copiedObjects[uniqueKey]["variant"][0]["quantity"] = parseInt(
          e.target.value
        );
        copiedObjects[uniqueKey]["variantObj"][variantName]["quantity"] =
          parseInt(e.target.value);
      }

      // Use ONLY calculated_price from variant - it's the full and final price per unit
      const variantObj = copiedObjects[uniqueKey]["variantObj"][variantName];
      const offerPrice = variant.offer_price || variantObj?.offer_price || 0;

      let finalPrice;
      if (offerPrice > 0) {
        // If offer_price exists, use it directly as the final price per unit
        finalPrice = parseInt(offerPrice);
      } else if (variant.calculated_price && variant.calculated_price > 0) {
        // Use calculated_price (final price from variantObj, e.g., 950)
        finalPrice = parseInt(variant.calculated_price);
      } else if (variantObj?.calculated_price && variantObj.calculated_price > 0) {
        // Use calculated_price from variantObj if not in variant
        finalPrice = parseInt(variantObj.calculated_price);
      } else {
        // Fallback: use variant.price which should already be set to calculated_price
        finalPrice = parseInt(variant.price || variantObj?.price || 0);
      }

      // Calculate total
      const quantity = parseInt(
        copiedObjects[uniqueKey]["variant"][0]["quantity"]
      );
      const total = quantity * finalPrice;

      copiedObjects[uniqueKey]["variant"][0]["total"] = total;
      copiedObjects[uniqueKey]["variantObj"][variantName]["total"] = total;

      // Update variant[0] to also use offer_price for consistency
      if (copiedObjects[uniqueKey]["variant"][0]) {
        if (offerPrice > 0) {
          copiedObjects[uniqueKey]["variant"][0]["price"] = offerPrice;
          copiedObjects[uniqueKey]["variant"][0]["offer_price"] = offerPrice;
        } else {
          copiedObjects[uniqueKey]["variant"][0]["price"] = finalPrice;
        }
      }

      // Update variantObj price and calculated_price
      if (offerPrice > 0) {
        copiedObjects[uniqueKey]["variantObj"][variantName]["price"] =
          offerPrice;
        copiedObjects[uniqueKey]["variantObj"][variantName]["offer_price"] =
          offerPrice;
      } else {
        copiedObjects[uniqueKey]["variantObj"][variantName]["price"] =
          finalPrice;
        // Preserve calculated_price if it exists
        if (variant.calculated_price || variantObj?.calculated_price) {
          copiedObjects[uniqueKey]["variantObj"][variantName]["calculated_price"] =
            variant.calculated_price || variantObj?.calculated_price;
        }
      }

      return copiedObjects;
    });
  };
  if (isLoading || !mainState) {
    return <Loader />;
  }
  console.log(paymentAllData, "============payment all data=============");
  console.log(
    invProduct,
    "============payment all data invoice_products============="
  );

  return (
    <div className="categorey-parent">
      <div
        className="invoice-b my-4 bg-white cat-child"
        style={{ borderTop: "0.5px solid #E0E0E0" }}
      >
        <h4 className=" my-2 mb-4 padding-main-head">Product Details</h4>
        <div className="border-p"></div>
        <div className="padding-main">
          <div className="main-select">
            <Select
              // styles={styles}
              isMulti
              placeholder="---Select---"
              isClearable
              onChange={handleMultiInputChange}
              defaultValue={defaultValue}
              options={ProductsList}
              onInputChange={inputProduct}
              isDisabled={true}
            />
          </div>

          <div className="mt-3">
            <div
              className="rounded"
              style={{
                background: "#FAFAFA",
                display: "block",
                overflowX: "hidden",
                width: "100%",
              }}
            >
              <div className="variant-list">
                {mainState !== undefined &&
                  Object.keys(mainState).map((curr) => {
                    const variant = mainState[curr]?.variant?.[0];
                    if (!variant) return null;
                    const productName =
                      mainState[curr]?.productName || curr.split("_")[0];
                    return (
                      <div key={curr} className="variant-item mb-3">
                        <div
                          className="variant-single-row p-3"
                          style={{
                            background: "white",
                            border: "1px solid #E0E0E0",
                            borderRadius: "8px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          }}
                        >
                          <div className="row align-items-center">
                            <div className="col-3">
                              <ImageZoom
                                className="d-flex align-items-center"
                                src={!isLoading && mainState[curr]?.["thumb"]}
                              >
                                <img
                                  width={50}
                                  height={50}
                                  src={!isLoading && mainState[curr]?.["thumb"]}
                                  alt="product"
                                  className="me-3 rounded shadow-sm"
                                  style={{
                                    border: "0.2px solid #bcb0b0",
                                    objectFit: "cover",
                                  }}
                                />
                                <div>
                                  <h6 className="mb-0 text-capitalize">
                                    {productName}
                                  </h6>
                                  <small className="text-muted">
                                    {variant.name}
                                  </small>
                                </div>
                              </ImageZoom>
                            </div>
                            <div className="col-2">
                              <label className="form-label small text-muted mb-1">
                                Price
                              </label>
                              <input
                                name="in_price"
                                value={getBasePlusVariant(curr, variant)}
                                className="form-control invoiceCreateSmallInputs"
                                placeholder="00.00"
                                type="text"
                                disabled
                              />
                            </div>
                            <div className="col-2">
                              <label className="form-label small text-muted mb-1">
                                Stock
                              </label>
                              <input
                                name="in_stock"
                                value={Number(variant.stock)}
                                className={`form-control invoiceCreateSmallInputs${
                                  Number(variant.stock) <= 0 ? " stock-out" : ""
                                }`}
                                placeholder="00.00"
                                type="text"
                                disabled
                              />
                            </div>
                            <div className="col-2">
                              <label className="form-label small text-muted mb-1">
                                Quantity
                              </label>
                              <input
                                disabled
                                name="in_quantity"
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                onChange={(e) => handleQuantity(e, curr, variant)}
                                className="form-control invoiceCreateSmallInputs"
                                placeholder="00.00"
                                value={
                                  variant.quantity === "-1" ||
                                  variant.quantity === -1
                                    ? 0
                                    : variant.quantity
                                }
                              />
                            </div>
                            <div className="col-3">
                              <label className="form-label small text-muted mb-1">
                                Total
                              </label>
                              <input
                                value={isNaN(variant.total) ? 0 : variant.total}
                                className="form-control invoiceCreateSmallInputs"
                                placeholder="00.00"
                                type="text"
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>

              <div className="d-flex flex-column flex-md-row mt-4 justify-content-between mx-4">
                {/* sub_total, delivery_charge, discount, total, paid_amount, Due_amount */}
                <div>
                  <h6>Total Item : {Object?.keys(mainState)?.length}</h6>
                </div>
                <div>
                  <div
                    className="d-flex justify-content-between "
                    style={{
                      color: "#212121",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    <p>Sub Total :</p>
                    <p className="ms-3 ">
                      <input
                        className="ms-3 invoiceInpCss"
                        type="text"
                        value={isNaN(getSubTotal()) ? 0 : getSubTotal()}

                        // value={Object.values(mainState)
                        // .map((curr) => curr.in_price * curr.in_quantity + curr.in_vat)
                        // .reduce((a, b) => a + b, 0)}
                      />
                    </p>
                  </div>

                  <div className="d-flex justify-content-between cl">
                    <p>Delivery Charge : </p>
                    <p className="ms-3 ">
                      <input
                        className="ms-3 invoiceInpCss"
                        onChange={(e) =>
                          setCustomCharge(Number(e.target.value))
                        }
                        type="number"
                        // onChange={(e) => console.log(e.target.value)}
                        value={getDeliveryCharge()}
                        style={{ border: "1px solid gray" }}
                      />
                    </p>
                  </div>

                  <div className="d-flex justify-content-between pl pt-2">
                    <p>Custom Price :</p>
                    <p className="ms-3 ">
                      <input
                        className="ms-3 invoiceInpCss paid_input_css"
                        name="custom_price"
                        type="number"
                        min="0"
                        value={customPrice}
                        onChange={(e) => setCustomPrice(e.target.value)}
                      />
                    </p>
                  </div>

                  <div className="d-flex justify-content-between pl pt-2">
                    <p>
                      Discount{" "}
                      {invoice_discount_type === "0" ||
                      invoice_discount_type === 0
                        ? ""
                        : "%"}{" "}
                      :
                    </p>
                    <p className="ms-3 ">
                      <input
                        className="ms-3 invoiceInpCss paid_input_css"
                        name="invoice_paid"
                        type="text"
                        value={Discount}
                        onChange={(e) => setDiscount(e.target.value)}
                      />
                    </p>
                  </div>
                  {sInvoice?.has_ssl_offer && (
                    <div className="d-flex justify-content-between pl pt-2">
                      <p>SSL Discount : </p>
                      <p className="ms-3 ">
                        <input
                          className="ms-3 invoiceInpCss paid_input_css"
                          name="invoice_paid"
                          type="text"
                          value={sInvoice?.ssl_discount_amount}
                          disabled
                          // onChange={(e) => setDiscount(e.target.value)}
                        />
                      </p>
                    </div>
                  )}

                  {sInvoice?.redeem_point >= 100 && (
                    <div className="d-flex justify-content-between pl pt-2">
                      <p>Redeem Discount :</p>
                      <p className="ms-3 ">
                        <input
                          className="ms-3 invoiceInpCss paid_input_css"
                          name="invoice_paid"
                          disabled
                          type="text"
                          value={sInvoice?.redeem_point}
                        />
                      </p>
                    </div>
                  )}

                  <div
                    className="d-flex justify-content-between"
                    style={{
                      color: "#212121",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    <p>Total amount :</p>
                    <p className="ms-3 ">
                      <input
                        className="ms-3 invoiceInpCss"
                        type="text"
                        value={isNaN(getGrandTotal()) ? 0 : getGrandTotal()}
                      />
                    </p>
                  </div>

                  <div className="d-flex justify-content-between pl pt-2">
                    <p>Paid amount :</p>
                    <p className="ms-3 ">
                      <input
                        className="ms-3 invoiceInpCss paid_input_css"
                        name="invoice_paid"
                        type="text"
                        value={paid}
                        onChange={(e) => setpaid(e.target.value)}
                      />
                    </p>
                  </div>

                  <div className="d-flex justify-content-between cl">
                    <p>Due amount :</p>
                    <p className="ms-3 ">
                      <input
                        className="ms-3 invoiceInpCss"
                        type="text"
                        name="invoice_due"
                        value={isNaN(getDueAmount()) ? 0 : getDueAmount()}
                      />
                    </p>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white cat-child ">
        <div
          className="d-flex align-items-center"
          style={{ padding: "20px 24px ", border: "0.5px solid #E0E0E0" }}
        >
          <h3
            style={{ fontSize: "23px", marginTop: "6px", marginLeft: "12px" }}
          >
            Invoice Details
          </h3>
        </div>
        {/* -----------product form---------- */}
        <div className="product-main createInvoiceInputContainer">
          <div className="row">
            <div className="col-12 col-md-6">
              <RequiredLabel text="Invoice Number" />

              <InputGroup className="mb-3">
                <Form.Control
                  disabled
                  aria-label="Username"
                  placeholder="Inv00014"
                  value={InvoiceAllData?.invoice_number}
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>
            <div className="col-12 col-md-6">
              <p>Barcode</p>
              <InputGroup className="mb-3">
                <Form.Control
                  disabled
                  placeholder="This will be generated automatically"
                  aria-label="Username"
                  value={InvoiceAllData?.invoice_barcode}
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6">
              <RequiredLabel text="Invoice Date" />
              <div className="position-relative">
                <InputGroup className="">
                  <Form.Control
                    type="date"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                    placeholder="Select a date"
                    name="invoice_date"
                    value={InvoiceAllData["invoice_date"]}
                    onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                  />
                </InputGroup>
                {/* <div className="calenderContainer">
                <CalendarBlank size={20} />
              </div> */}
              </div>
            </div>

            <div className="col-12 col-md-6">
              <RequiredLabel text={"Delivery Type"} />
              <div className="mb-3" style={{ height: "47px" }}>
                <Form.Select
                  size="lg"
                  placeholder="---Select---"
                  onChange={(e) => setinvoice_delivery_type(e.target.value)}
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                >
                  <option value={0}>Regular</option>
                  <option value={1}>Urgent</option>
                </Form.Select>
              </div>
            </div>

            {/* 
            <div className="col-12 col-md-6 ">
              <RequiredLabel text="Due Date" />

              <div className="position-relative ">
                <InputGroup className="mb-3">
                  <Form.Control
                    type="date"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                    placeholder="Select a date"
                    name="invoice_due_date"
                    value={InvoiceAllData["invoice_due_date"]}
                    onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                  />
                </InputGroup>
         
              </div>
            </div> */}
            <div className="col-12 col-md-6">
              <RequiredLabel text="From Mobile" />

              <div className="d-flex phoneContainer ">
                <PhoneInput
                  inputClass="phoneinput"
                  disableDropdown
                  onChange={(e) => setFromCode(e)}
                  country={"bd"}
                />
                {/* <PhoneInput inputClass="phoneinput" onChange={(e) => setFromCode(e)} enableSearch={true} country={"bd"} /> */}
                <div className="w-100">
                  <Form.Control
                    aria-label="Input number"
                    placeholder="Input number"
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                    className="phone_insert_input"
                    name="invoice_from_mobile"
                    value={InvoiceAllData["invoice_from_mobile"]?.replace(
                      "+880",
                      ""
                    )}
                    onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                  />
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 mb-3">
              <RequiredLabel text="To Mobile" />
              <div className="d-flex phoneContainer ">
                <PhoneInput
                  inputClass="phoneinput"
                  disableDropdown
                  onChange={(e) => setFromCode(e)}
                  country={"bd"}
                />
                {/* <PhoneInput inputClass="phoneinput" onChange={(e) => setToCode(e)} enableSearch={true} country={"bd"} /> */}
                <div className="w-100">
                  {/* <Form.Control
                    aria-label="Input number"
                    placeholder="Input number"
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                    className="phone_insert_input"
                    name="invoice_to_mobile"
                    value={InvoiceAllData["invoice_to_mobile"]?.replace(
                      "+880",
                      ""
                    )}
                    onChange={(e) => toPhoneHandle(e)}
                  /> */}
                  <Form.Control
                    aria-label="Input number"
                    placeholder="Input number"
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                    className="phone_insert_input"
                    name="invoice_to_mobile"
                    value={InvoiceAllData["invoice_to_mobile"]?.replace(
                      "+880",
                      ""
                    )}
                    onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <RequiredLabel text="Bill From" />

              <InputGroup className="mb-3">
                <Form.Control
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                  name="invoice_bill_from"
                  value={InvoiceAllData["invoice_bill_from"]}
                  onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                />
              </InputGroup>
            </div>
            <div className="col-12 col-md-6 ">
              <RequiredLabel text="Bill To" />
              {console.log("FoundCustomer", FoundCustomer)}
              <InputGroup className="mb-3">
                <Form.Control
                  name="invoice_bill_to"
                  value={
                    Found
                      ? FoundCustomer.name
                      : InvoiceAllData["invoice_bill_to"]
                  }
                  onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>

            {/* new  */}

            <div className="col-12 col-md-6 mt-3">
              <RequiredLabel text={"Delivery Charge"} />
              <div className="mb-3" style={{ height: "47px" }}>
                <Form.Select
                  size="lg"
                  placeholder="---Select---"
                  value={invoice_delivery_charge}
                  onChange={(e) => {
                    if (Number(e.target.value) === 0) {
                      setCustomCharge(80);
                    } else if (Number(e.target.value) === 1) {
                      setCustomCharge(150);
                    }
                    setinvoice_delivery_charge(e.target.value);
                  }}
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                >
                  <option value={0}>Inside Dhaka : 80/-</option>
                  <option value={1}>Outside Dhaka : 150/-</option>
                  <option value={2}>Custom</option>
                </Form.Select>

                {/* <Select
                  placeholder="---Select---"
                  isClearable
                  styles={{height:"100%"}}
                  options={deliveryPrice_options}
                  defaultValue={deliveryPrice_options.filter((curr) => curr.value === invoice_delivery_charge)[0]}
                  onChange={(option) => setinvoice_delivery_charge(option.value)}
                /> */}
              </div>
            </div>

            <div className="col-12 col-md-6 mt-3">
              <RequiredLabel text={"Discount Type"} />
              <div className="" style={{ height: "47px" }}>
                <Form.Select
                  size="lg"
                  placeholder="---Select---"
                  onChange={(e) => setinvoice_discount_type(e.target.value)}
                  value={invoice_discount_type}
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                >
                  <option value={0}>Flat </option>
                  <option value={1}>Percentage</option>
                </Form.Select>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <RequiredLabel text="From Email" />

              <InputGroup className="mb-3">
                <Form.Control
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                  name="invoice_from_email"
                  value={InvoiceAllData["invoice_from_email"]}
                  onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6 ">
              {/* <RequiredLabel text="To Email" /> */}
              <p>To Email</p>
              <InputGroup className="mb-3">
                <Form.Control
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                  name="invoice_to_email"
                  value={InvoiceAllData["invoice_to_email"]}
                  onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6">
              <RequiredLabel text="From Address" />

              <InputGroup className="mb-3 addressInput">
                <Form.Control
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                  name="invoice_from_address"
                  value={InvoiceAllData["invoice_from_address"]}
                  onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                />
              </InputGroup>
            </div>
            <div className="col-12 col-md-6"></div>

            <div className="col-12 col-md-6">
              <RequiredLabel text="To Address 1" />

              <InputGroup className=" addressInput">
                <Form.Control
                  aria-label="Username"
                  name="invoice_to_address"
                  value={
                    Found
                      ? FoundCustomer.address
                      : InvoiceAllData["invoice_to_address"]
                  }
                  onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6">
              <p>To Address 2</p>

              <InputGroup className="mb-3 addressInput">
                <Form.Control
                  aria-label="Username"
                  name="invoice_to_address2"
                  value={
                    Found
                      ? FoundCustomer.address
                      : InvoiceAllData["invoice_to_address2"]
                  }
                  onChange={(e) =>
                    Found
                      ? setFoundCustomer({
                          ...FoundCustomer,
                          address: e.target.value,
                        })
                      : handleInputs(e, SetInvoiceAllData)
                  }
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>
            {/* zip */}

            {/* new address inputs start */}
            <div className="col-12 col-md-6">
              <RequiredLabel text="Delivery Service" />
              <Select
                onChange={(newval) => setDeliveryService(newval)}
                options={[
                  {
                    label: "Pathao",
                    value: 0,
                  },
                  {
                    label: "Others",
                    value: 1,
                  },
                ]}
                value={deliveryService}
                placeholder="Select "
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused ? "#e0e0e0" : "#e0e0e0",
                    boxShadow: state.isFocused
                      ? "0 0 0px 0.5px rgba(255, 0, 0, 1)"
                      : "none",
                    "&:hover": {
                      borderColor: "#e0e0e0",
                    },
                    maxHeight: "120px",
                    overflowY: "auto",
                  }),
                  multiValueContainer: (baseStyles) => ({
                    ...baseStyles,
                    overflowY: "auto",
                    maxHeight: "120px",
                    display: "flex",
                    flexWrap: "wrap",
                  }),
                }}
              />
            </div>

            {deliveryService?.value === 1 ? (
              <>
                <div className="col-12 col-md-6">
                  <RequiredLabel text="To Division" />

                  <Controller
                    name="division"
                    control={control}
                    // rules={{ required: true }}
                    render={({ field }) => (
                      <Select
                        isSearchable
                        {...field}
                        value={selectedDivision}
                        onChange={handleDivisionChange}
                        // styles={customStyles}
                        options={divisions.map(({ name, id }) => {
                          return { label: name, value: id };
                        })}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: state.isFocused
                              ? "#e0e0e0"
                              : "#e0e0e0",
                            boxShadow: state.isFocused
                              ? "0 0 0px 0.5px rgba(255, 0, 0, 1)"
                              : "none",
                            "&:hover": {
                              borderColor: "#e0e0e0",
                            },
                            maxHeight: "120px",
                            overflowY: "auto",
                          }),
                          multiValueContainer: (baseStyles) => ({
                            ...baseStyles,
                            overflowY: "auto",
                            maxHeight: "120px",
                            display: "flex",
                            flexWrap: "wrap",
                          }),
                        }}
                      />
                    )}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <RequiredLabel text="To District" />
                  {/* <p>*</p> */}
                  <Controller
                    name="district"
                    control={control}
                    // rules={{ required: true }}
                    render={({ field }) => (
                      <Select
                        isLoading={selectLoading}
                        isSearchable
                        {...field}
                        value={selectedDistrict}
                        onChange={handleDistrictChange}
                        // styles={customStyles}
                        // defaultValue={ label: "", value: "" }
                        options={districtList?.map(({ name, id }) => {
                          return { label: name, value: id };
                        })}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: state.isFocused
                              ? "#e0e0e0"
                              : "#e0e0e0",
                            boxShadow: state.isFocused
                              ? "0 0 0px 0.5px rgba(255, 0, 0, 1)"
                              : "none",
                            "&:hover": {
                              borderColor: "#e0e0e0",
                            },
                            maxHeight: "120px",
                            overflowY: "auto",
                          }),
                          multiValueContainer: (baseStyles) => ({
                            ...baseStyles,
                            overflowY: "auto",
                            maxHeight: "120px",
                            display: "flex",
                            flexWrap: "wrap",
                          }),
                        }}
                      />
                    )}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <RequiredLabel text="To City" />

                  <Controller
                    name="town"
                    control={control}
                    // rules={{ required: true }}
                    render={({ field }) => (
                      <Select
                        isSearchable
                        {...field}
                        value={selectedTown}
                        onChange={handleTownChange}
                        // styles={customStyles}
                        // defaultValue={ label: "", value: "" }
                        options={upazillaList?.map(({ name, id }) => {
                          return { label: name, value: id };
                        })}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: state.isFocused
                              ? "#e0e0e0"
                              : "#e0e0e0",
                            boxShadow: state.isFocused
                              ? "0 0 0px 0.5px rgba(255, 0, 0, 1)"
                              : "none",
                            "&:hover": {
                              borderColor: "#e0e0e0",
                            },
                            maxHeight: "120px",
                            overflowY: "auto",
                          }),
                          multiValueContainer: (baseStyles) => ({
                            ...baseStyles,
                            overflowY: "auto",
                            maxHeight: "120px",
                            display: "flex",
                            flexWrap: "wrap",
                          }),
                        }}
                      />
                    )}
                  />
                </div>
              </>
            ) : (
              <>
                {/* parhao data */}
                <CreateWithPathaoWeb
                  pathaoCity={pathaoCity}
                  setPathaoCity={setPathaoCity}
                  pathaoZone={pathaoZone}
                  setPathaoZone={setPathaoZone}
                  pathaoArea={pathaoArea}
                  setPathaoArea={setPathaoArea}
                  mainState={(() => {
                    // Convert mainState object to array format expected by CreateWithPathaoWeb
                    const result = [];
                    Object.keys(mainState).forEach((key) => {
                      const product = mainState[key];
                      if (
                        product &&
                        product.variant &&
                        product.variant.length > 0
                      ) {
                        product.variant.forEach((variant) => {
                          if (parseInt(variant.quantity) > 0) {
                            result.push({
                              product: product.id,
                              final_quantity: parseInt(variant.quantity),
                            });
                          }
                        });
                      }
                    });
                    return result;
                  })()}
                  setCustomCharge={setCustomCharge}
                  subTotal={isNaN(getSubTotal()) ? 0 : getSubTotal()}
                />
                {/* parhao data */}
              </>
            )}
            <div className="col-12 col-md-6">
              {/* <RequiredLabel text="To Division" /> */}
              <p>Post Code</p>
              {/* <Controller
                  name="zip"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Select
                      isSearchable
                      {...field}
                      styles={customStyles}
                      options={zipList.map(({ name, postCode }) => {
                        return {
                          label: `${name}-${postCode}`,
                          value: postCode,
                        };
                      })}
                    />
                  )}
                /> */}
              <input type="text" {...register("zip")} />
            </div>
            {/* new address input end */}
            {/* country */}
            {/* <div className="col-12 col-md-6 d-none">
              <RequiredLabel text="To Country" />

              <InputGroup className="mb-3 addressInput">
                <Form.Control
                  aria-label="Username"
                  name="to_country"
                  value={
                    Found
                      ? FoundCustomer.to_country
                      : InvoiceAllData["to_country"]
                  }
                  onChange={(e) =>
                    Found
                      ? setFoundCustomer({
                          ...FoundCustomer,
                          to_country: e.target.value,
                        })
                      : handleInputs(e, SetInvoiceAllData)
                  }
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div> */}
            <div className="col-12 col-md-6 ">
              <RequiredLabel text={"Payment Type"} />
              {/* <RequiredLabel text={"Payment Type"} /> */}
              <div className="mb-3">
                <Form.Select
                  size="lg"
                  placeholder="---Select---"
                  onChange={(e) => {
                    setinvoice_payment_type(e.target.value);
                  }}
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                  value={invoice_payment_type}
                >
                  {paymentType.map((curr) => {
                    return <option value={curr.value}>{curr.label}</option>;
                  })}
                </Form.Select>
              </div>
            </div>
            <div className="col-12 col-md-6">
              {/* <RequiredLabel text="To District" /> */}
              <p>Reference ID</p>
              <InputGroup className="mb-3 addressInput">
                <Form.Control
                  aria-label="Username"
                  name="reference_id"
                  value={paymentAllData["reference_id"]}
                  onChange={(e) => handleInputs(e, setPaymentAllData)}
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>
          </div>
        </div>
      </div>

      {/* {
          invoice_payment_type !== 0 || invoice_payment_type !== '0' &&
        } */}

      <div
        className={`invoice-b my-4 bg-white cat-child ${
          invoice_payment_type === 0 ||
          invoice_payment_type === "0" ||
          invoice_payment_type === 6 ||
          invoice_payment_type === "6"
            ? "d-none"
            : ""
        }`}
        style={{ borderTop: "0.5px solid #E0E0E0" }}
      >
        <h4 className=" my-2 mb-4 padding-main-head">Payment Details</h4>
        <div className="border-p"></div>
        {/* ==========for bKash========== */}
        {invoice_payment_type === 5 ||
          (invoice_payment_type === "5" && (
            <div className="padding-main row">
              <div className="col-12 col-md-6">
                {/* <RequiredLabel text="bKash Number" /> */}
                <p>Nagad Number</p>

                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                    name="nagad_number"
                    value={paymentAllData["nagad_number"]}
                    onChange={(e) => handleInputs(e, setPaymentAllData)}
                  />
                </InputGroup>
              </div>
              <div className="col-12 col-md-6">
                {/* <RequiredLabel text="TRX Number" /> */}
                <p>TNX Number</p>
                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                    name="nagad_trx_number"
                    value={paymentAllData["nagad_trx_number"]}
                    onChange={(e) => handleInputs(e, setPaymentAllData)}
                  />
                </InputGroup>
              </div>
            </div>
          ))}
        {(invoice_payment_type === 3 || invoice_payment_type === "3") && (
          <div className="padding-main row">
            <div className="col-12 col-md-6">
              {/* <RequiredLabel text="bKash Number" /> */}
              <p>BKash Number</p>

              <InputGroup className="mb-3 addressInput">
                <Form.Control
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                  name="bkash_number"
                  value={paymentAllData["bkash_number"]}
                  onChange={(e) => handleInputs(e, setPaymentAllData)}
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6">
              {/* <RequiredLabel text="TRX Number" /> */}
              <p>TNX Number</p>

              <InputGroup className="mb-3 addressInput">
                <Form.Control
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                  name="bkash_trx_number"
                  value={paymentAllData["bkash_trx_number"]}
                  onChange={(e) => handleInputs(e, setPaymentAllData)}
                />
              </InputGroup>
            </div>
          </div>
        )}
        {/* ==========for bKash========== */}
        {/* ===========For Bank Transfer */}
        {(invoice_payment_type === 2 || invoice_payment_type === "2") && (
          <div className="padding-main row">
            <div className="col-12 col-md-6">
              {/* <RequiredLabel text="Bank Name" /> */}
              <p>Bank Name</p>
              <InputGroup className="mb-3 addressInput">
                <Form.Control
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                  name="bank_name"
                  value={paymentAllData["bank_name"]}
                  onChange={(e) => handleInputs(e, setPaymentAllData)}
                />
              </InputGroup>
            </div>
            <div className="col-12 col-md-6">
              {/* <RequiredLabel text="Branch Name" /> */}
              <p>Branch Name</p>

              <InputGroup className="mb-3 addressInput">
                <Form.Control
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                  name="banK_branch_name"
                  value={paymentAllData["banK_branch_name"]}
                  onChange={(e) => handleInputs(e, setPaymentAllData)}
                />
              </InputGroup>
            </div>
            <div className="col-12 col-md-6">
              {/* <RequiredLabel text="Acount Number" /> */}
              <p>Account Number</p>

              <InputGroup className="mb-3 addressInput">
                <Form.Control
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                  name="banK_account_number"
                  value={paymentAllData["banK_account_number"]}
                  onChange={(e) => handleInputs(e, setPaymentAllData)}
                />
              </InputGroup>
            </div>
            <div className="col-12 col-md-6">
              {/* <RequiredLabel text="Account Name" /> */}
              <p>Account Name</p>
              {/* <RequiredLabel text="Account Name" /> */}

              <InputGroup className="mb-3 addressInput">
                <Form.Control
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                  name="banK_account_name"
                  value={paymentAllData["banK_account_name"]}
                  onChange={(e) => handleInputs(e, setPaymentAllData)}
                />
              </InputGroup>
            </div>
          </div>
        )}

        {/* ===========For Bank Transfer=============== */}
        {/* ===========For Card Payment=============== */}
        {(invoice_payment_type === 1 || invoice_payment_type === "1") && (
          <div className="padding-main row">
            <div className="col-12 col-md-6">
              {/* <RequiredLabel text="Card Number" /> */}
              <p>Card Number</p>

              <InputGroup className="mb-3 addressInput">
                <Form.Control
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                  name="card_number"
                  value={paymentAllData["card_number"]}
                  onChange={(e) => handleInputs(e, setPaymentAllData)}
                />
              </InputGroup>
            </div>
            <div className="col-12 col-md-6">
              {/* <RequiredLabel text="Card Holder Name" /> */}
              <p>Card Holder Name</p>

              <InputGroup className="mb-3 addressInput">
                <Form.Control
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                  name="card_holder_name"
                  value={paymentAllData["card_holder_name"]}
                  onChange={(e) => handleInputs(e, setPaymentAllData)}
                />
              </InputGroup>
            </div>
          </div>
        )}

        {/* ===========For Card Payment=============== */}
      </div>
      {/* ====================attribute=================== */}

      {/* ====================attribute=================== */}
      <div
        className="product-main my-4 bg-white cat-child"
        style={{ borderTop: "0.5px solid #E0E0E0" }}
      >
        <div>
          <p>Payment Status</p>
          {/* <SelectDropDownForInvoice
            options={invoice_choices}
            defaultValue={invoice_choices.filter((curr) => curr.value === InvoiceAllData["invoice_payment_status"])[0]}
            setSelectedOptionCategory={setinvoice_status}
          /> */}
          <Select
            placeholder="---Select---"
            isClearable
            options={invoice_choices}
            defaultValue={
              invoice_choices.filter((curr) => curr.value === invoice_status)[0]
            }
            onChange={(option) => setinvoice_status(option.value)}
          />

          <p className="mt-4">Delivery Status</p>

          {/* <SelectDropDownForInvoice
            options={delivery_choices}
            defaultValue={delivery_choices.filter((curr) => curr.value === InvoiceAllData["invoice_delivery_status"])[0]}
            setSelectedOptionCategory={setDelivrey_status}
          /> */}

          <Select
            placeholder="---Select---"
            isClearable
            options={delivery_choices}
            defaultValue={
              delivery_choices.filter(
                (curr) => curr.value === Delivery_status
              )[0]
            }
            onChange={(option) => setDelivrey_status(option.value)}
          />
          {console.log("delivery status", Delivery_status)}

          {/* notes */}
          <div className="mt-3 d-flex align-content-center">
            <PencilSimple size={12} weight="light" className="mt-0 pe-1" />{" "}
            <p style={{ color: "#333333" }} className="mb-2">
              Notes
            </p>
          </div>
          <Form.Control
            as="textarea"
            placeholder=""
            className="mb-3"
            name="invoice_notes"
            value={InvoiceAllData["invoice_notes"]}
            onChange={(e) => handleInputs(e, SetInvoiceAllData)}
            style={{
              height: "100px",
              resize: "none",
              backgroundColor: "#FAFAFA",
            }}
          />
        </div>

        <div className="row d-flex justify-content-between"></div>
      </div>

      <div
        className="floating-bar padding-btn-head mb-4 d-flex justify-content-end  bg-white cat-child"
        style={{ border: "0.5px solid #E0E0E0" }}
      >
        <div className="" style={{ marginLeft: "-10px" }}>
          <button
            className="btn rounded border align-items-center d-none me-2 mt-2 "
            disabled={!InvoiceAllData}
            onClick={handlePrint2}
          >
            <DoIcon className="doc" /> Preview PDF
          </button>
          {/* <button onClick={postInvoiceProduct} className="btn rounded border me-2 mt-2"> */}
          <button
            onClick={() => ValidateData(false)}
            className="btn rounded border me-2 mt-2"
          >
            Save Invoice
          </button>
          {InvoiceAllData["invoice_to_email"] !== "" &&
            !Found &&
            validateEmail(InvoiceAllData["invoice_to_email"]) && (
              <button
                onClick={SaveAndSendEmail}
                className="btn rounded border text-white mt-2"
                style={{ background: "black" }}
              >
                Save & Send PDF
              </button>
            )}

          <button
            className="btn rounded border me-2 ms-2 mt-2"
            onClick={() => history.push(path.invoice_list)}
          >
            Cancel
          </button>
          {/* 
          {Found && FoundCustomer?.email !== "" && validateEmail(InvoiceAllData["invoice_to_email"]) && (
            <button
              onClick={() => {
                set_is_send_email(true);
                ValidateData();
                console.log("save and send working");
              }}
              className="btn rounded border text-white mt-2"
              style={{ background: "black" }}
            >
              Save & Send PDF
            </button>
          )} */}
          <div className="d-none">
            <PreviewEdit
              print={print}
              status={invoice_payment_type}
              Found={Found}
              InvoiceAllData={InvoiceAllData}
              FoundCustomer={FoundCustomer}
              mainState={mainState}
              // jData={jData}
            ></PreviewEdit>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditWebInvoiceUpdated;
